
import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';

export function PlanItem({ item }) {
  return (
    <div className={ `flex flex-row items-start` }>
      <item.icon className={ `w-5 h-5 text-paidniceGreen-600 mt-0.5` } />
      <div className={ `ml-3` }>
        <span className={ `text-sm sm:text-base text-gray-800` }>
          { item.text }
        </span>
        <Paragraph variant={ `help` }
          size={ `xs` }>
          { item.subText }
        </Paragraph>
      </div>
    </div>
  );
}
